import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const DownloadChallanPdf = (allChallans, companyName, logo, setOpenBackdrop) => {
    // Check if data exists
    const challanList = Array.isArray(allChallans) ? allChallans : [allChallans];

    if (challanList.length === 0) {
        alert("No data found to print!");
        return;
    }

    const doc = new jsPDF();
    setOpenBackdrop(true);

    try {
        challanList.forEach((challan, index) => {
            // Agar pehla page nahi hai, to naya page add karo
            if (index > 0) {
                doc.addPage();
            }

            // --- 1. Header Section ---
            if (logo) {
                doc.addImage(logo, 'PNG', 14, 10, 15, 15);
            }
            
            doc.setFontSize(16);
            doc.setTextColor(25, 118, 210);
            doc.text(companyName || 'COMPANY NAME', 35, 18);
            
            doc.setFontSize(10);
            doc.setTextColor(100);
            doc.text('DELIVERY CHALLAN', 160, 18);

            doc.setLineWidth(0.5);
            doc.line(14, 28, 196, 28);

            // --- 2. Customer & Challan Info ---
            doc.setFontSize(10);
            doc.setTextColor(0);
            
            // Left Column: Bill & Ship To
            doc.setFont("helvetica", "bold");
            doc.text("Bill To:", 14, 38);
            doc.setFont("helvetica", "normal");
            doc.text(challan.customer?.contact_name || 'N/A', 14, 43);
            const billAddr = doc.splitTextToSize(challan.bill_to_address || 'N/A', 80);
            doc.text(billAddr, 14, 48);

            doc.setFont("helvetica", "bold");
            doc.text("Ship To:", 14, 65);
            doc.setFont("helvetica", "normal");
            const shipAddr = doc.splitTextToSize(challan.ship_to_address || 'N/A', 80);
            doc.text(shipAddr, 14, 70);

            // Right Column: Details
            doc.setFont("helvetica", "bold");
            doc.text(`Challan No :`, 130, 38);
            doc.setFont("helvetica", "normal");
            doc.text(`${challan.challan_no}`, 160, 38);

            doc.setFont("helvetica", "bold");
            doc.text(`Date       :`, 130, 44);
            doc.setFont("helvetica", "normal");
            doc.text(`${challan.challan_date}`, 160, 44);

            doc.setFont("helvetica", "bold");
            doc.text(`PO No      :`, 130, 50);
            doc.setFont("helvetica", "normal");
            doc.text(`${challan.purchase_order_no || 'N/A'}`, 160, 50);

            // --- 3. Items Table ---
            const tableHeaders = [['S.No', 'Item Name', 'Qty']];
             // const tableHeaders = [['S.No', 'Item Name', 'Qty', 'Rate', 'Amount']];
            const tableData = (challan.items || []).map((item, idx) => [
                idx + 1,
                item.itemname,
                item.qty,
                //Number(item.rate).toFixed(2),
               // Number(item.amount).toFixed(2)

            ]);

            doc.autoTable({
                startY: 85,
                head: tableHeaders,
                body: tableData,
                theme: 'grid',
                headStyles: { fillColor: [25, 118, 210] },
                styles: { fontSize: 9 },
                columnStyles: {
                    0: { cellWidth: 12 },
                    2: { halign: 'center' },
                  //  3: { halign: 'right' },
                   // 4: { halign: 'right' },
                }
            });

            // --- 4. Footer & Totals ---
            const finalY = doc.lastAutoTable.finalY;
            
            // Total Box
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            doc.text(`Total Amount: Rs. ${Number(challan.total_amount).toFixed(2)}`, 140, finalY + 15);

            // Page Number in footer
            doc.setFontSize(8);
            doc.setFont("helvetica", "italic");
            doc.setTextColor(150);
            doc.text(`Page ${index + 1} of ${challanList.length}`, 105, 290, { align: 'center' });
            doc.text("This is a computer generated document.", 105, 285, { align: 'center' });
        });

        // Save the file with bulk name
        const timestamp = new Date().getTime();
        doc.save(`Bulk_Challans_${timestamp}.pdf`);

    } catch (error) {
        console.error("PDF Generation Error:", error);
        alert("Something went wrong while generating PDF");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadChallanPdf;